<div class="custom-data__container">
  <header class="custom-data__header">
    <h2 class="custom-data__header-title">
      {{ componentFor === DataFieldFor.Contact ? "Contact" : "Client" }} Data
    </h2>
    <p class="custom-data__header-description">
      <span *ngIf="componentFor === DataFieldFor.Contact">
        As described in the previous section, each Client will have a set of one
        or more Contacts, which are the individuals that you work with in that
        client. You can store information like email address, phone number for
        each Contact.
        <span class="mt-2 d-block"
          >In this section, you can add/remove the data fields you want to track
          for each Contact.</span
        >
      </span>
      <span *ngIf="componentFor !== DataFieldFor.Contact">
        In Client Hub, we have two levels of client information: Clients and
        Contacts. The “Client” is a small business that you serve, and there is
        data at the company level like “Entity type” or “Website” associated
        with a client. Each client will have one or more Contacts, where you
        keep each person’s details like email and phone. If you service clients
        that are not businesses, you can set them up with “Smith Family”, “Jane
        Doe” etc. as the Client names and still add their details into Contacts.
        <span class="mt-2 d-block"
          >In this section, you can add/remove the data fields you want to track
          for each Client and in the next section, you can define the fields for
          a Contact.</span
        >
      </span>
    </p>
  </header>
  <div class="table-container" [ngClass]="{ 'component-loading': isLoading }">
    <table class="table">
      <thead>
        <tr class="table-header">
          <th style="width: 20px"></th>
          <th>Field Name</th>
          <th>Type</th>
          <th>Options</th>
          <th>Required</th>
          <th></th>
        </tr>
      </thead>
      <tbody
        class="table-body"
        dragula="FIELDS"
        [dragulaModel]="data"
        (dragulaModelChange)="data = $event"
      >
        <tr
          (click)="selectDataField(field)"
          [ngClass]="{ selected: field.uuid === selectedDataField?.uuid }"
          class="table-row"
          *ngFor="let field of data"
        >
          <td>
            <svg
              style="margin-top: 2px; cursor: grab"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
            >
              <circle cx="1" cy="1" r="1" fill="#C7C7C7" />
              <circle cx="5" cy="1" r="1" fill="#C7C7C7" />
              <circle cx="9" cy="1" r="1" fill="#C7C7C7" />
              <circle cx="1" cy="5" r="1" fill="#C7C7C7" />
              <circle cx="5" cy="5" r="1" fill="#C7C7C7" />
              <circle cx="9" cy="5" r="1" fill="#C7C7C7" />
              <circle cx="1" cy="9" r="1" fill="#C7C7C7" />
              <circle cx="5" cy="9" r="1" fill="#C7C7C7" />
              <circle cx="9" cy="9" r="1" fill="#C7C7C7" />
              <circle cx="1" cy="13" r="1" fill="#C7C7C7" />
              <circle cx="5" cy="13" r="1" fill="#C7C7C7" />
              <circle cx="9" cy="13" r="1" fill="#C7C7C7" />
              <circle cx="1" cy="17" r="1" fill="#C7C7C7" />
              <circle cx="5" cy="17" r="1" fill="#C7C7C7" />
              <circle cx="9" cy="17" r="1" fill="#C7C7C7" />
            </svg>
          </td>
          <td>{{ field.name }}</td>
          <td>{{ DataFieldTypeMappingDisplay[field.type] }}</td>
          <td>
            <p-overlayPanel #showOptionsFull>
              <span class="options-overlay-text">{{
                showFieldOptions(field, false)
              }}</span>
            </p-overlayPanel>
            <span
              style="cursor: pointer"
              (click)="showOptionsFull.toggle($event)"
              >{{ showFieldOptions(field) }}</span
            >
          </td>
          <td>
            <i
              *ngIf="field.required"
              style="margin-left: 25px"
              class="feather check"
            ></i>
          </td>
          <td>
            <div
              *ngIf="!field.required"
              class="delete-button"
              (click)="deleteField(field)"
            >
              <i class="feather trash color-red"></i>
              <span>Delete field</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="custom-data__manager">
    <h2 *ngIf="data.length === 0" class="custom-data__manager-label">
      Add you first field using the form below
    </h2>
    <form class="custom-data__manager-form">
      <div class="custom-data__manager-form--field">
        <label for="name">Field Name</label>
        <div class="field-input">
          @if (selectedDataField.name) {
            <input
              [(ngModel)]="selectedDataField.name"
              name="name"
              id="name"
              type="text"
            />
          } @else {
            <input
              [(ngModel)]="fieldName"
              name="name"
              id="id"
              placeholder="Add field name"
              type="text"
            />
          }
        </div>
      </div>
      <div class="custom-data__manager-form--field">
        <label for="type">Type</label>
        <div class="field-input">
          <select
            [disabled]="selectedDataField.type !== ''"
            name="field"
            id="field"
            [value]="
              selectedDataField?.type ? selectedDataField?.type : fieldType
            "
            (change)="
              selectedDataField?.type
                ? (selectedDataField.type = $event.target.value)
                : (fieldType = $event.target.value)
            "
          >
            <option value="" disabled selected>Select your option</option>
            <option value="string">Text</option>
            <option value="number">Number</option>
            <option value="date">Date</option>
            <option value="boolean">Boolean</option>
            <option value="email">Email</option>
            <option value="phone_number">Phone number</option>
            <option value="url">Url</option>
            <option value="list">Select</option>
          </select>
        </div>
      </div>

      @if (!selectedDataField?.type) {
        <button
          [ngClass]="{ 'component-loading': loadingAddField }"
          class="btn btn-primary"
          (click)="addNewField()"
          [disabled]="!(fieldName && fieldType)"
        >
          Add field
        </button>
      } @else {
        <button
          [ngClass]="{ 'component-loading': loadingAddField }"
          class="btn btn-primary"
          (click)="editDataField()"
        >
          Save changes
        </button>
        <button class="btn btn-default" (click)="unselectDataField()">
          Cancel
        </button>
      }
    </form>

    @if (
      selectedDataField?.type
        ? selectedDataField?.type === "list"
        : fieldType === "list"
    ) {
      <div class="custom-data__manager-options">
        <div class="flex-column">
          <label class="field-label" for="options">Options</label>
          <div class="custom-data__manager-options--input">
            @if (selectedDataField.uuid != null) {
              <!-- <p-chips
                [(ngModel)]="selectedDataField.select_options"
                [ngModelOptions]="{ standalone: true }"
                separator=","
                [addOnTab]="true"
                [addOnBlur]="true"
                [showClear]="true"
              ></p-chips> -->
              <p-autocomplete
                placeholder="Add options"
                multiple
                fluid
                [(ngModel)]="selectedDataField.select_options"
                [typeahead]="false"
                (onBlur)="onBlur($event)"
              />
            } @else {
              <p-autocomplete
                placeholder="Add options"
                multiple
                fluid
                [(ngModel)]="select_options"
                [typeahead]="false"
                (onBlur)="onBlur($event)"
              />

              <!-- <p-chips
                [(ngModel)]="select_options"
                [ngModelOptions]="{ standalone: true }"
                separator=","
                [addOnTab]="true"
                [addOnBlur]="true"
                [showClear]="true"
              ></p-chips> -->
            }
          </div>
        </div>
        <button class="btn btn-default" (click)="openReorderOptionsModal()">
          Reorder Options
        </button>
      </div>
    }
  </div>
</div>
